//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "member-extend",
  data() {
    return {
      memberExtendInputDto: {
        occupation: '',
        purpose: '',
        familyCount: '',
        childAge: '',
        carCount: '',
        isHavePets: false,
        isHavePetsStr: '',
        childrenNum: 0
      },
      occupationActionShow: false,
      purposeActionShow: false,
      familyCountActionShow: false,
      childAgeActionShow: false,
      firstChildAgeActionShow: false,
      secondChildAgeActionShow: false,
      thirdChildAgeActionShow: false,
      carCountActionShow: false,
      isHavePetsActionShow: false,
      childrenNumActionShow: false,
      columns: [
        '政府单位',
        '教师',
        '律师',
        '其他从业人员',
        '个体户',
        '房地产相关行业',
        '媒体相关',
        '企事业单位',
      ],
      purposeColumns: [
        '首次置业',
        '改善',
        '投资',
        '赠与亲友',
        '其他',
      ],
      familyCountColumns: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '大于6',
      ],
      childAgeColumns: [
        '0-3岁',
        '4-6岁',
        '7-12岁',
        '13-18岁',
        '大于18岁',
      ],
      carCountColumns: [
        '无',
        '1辆',
        '2辆及以上',
      ],
      isHavePetsColumns: [
        '是', '否'
      ],
      childrenNumColumns: [0, 1, 2, 3]
    }
  },
  methods: {
    onCancel() {
      this.occupationActionShow = false;
      this.purposeActionShow = false;
      this.familyCountActionShow = false;
      this.childAgeActionShow = false;
      this.carCountActionShow = false;
      this.isHavePetsActionShow = false;
      this.firstChildAgeActionShow = false;
      this.secondChildAgeActionShow = false;
      this.thirdChildAgeActionShow = false;
      this.childrenNumActionShow = false;
    },
    occupationConfirm(value) {
      this.occupationActionShow = false;
      this.memberExtendInputDto.occupation = value
      this.handleMemberExtend();
    },
    purposeConfirm(value) {
      this.purposeActionShow = false;
      this.memberExtendInputDto.purpose = value
      this.handleMemberExtend();
    },
    familyCountConfirm(value) {
      this.familyCountActionShow = false;
      this.memberExtendInputDto.familyCount = value
      this.handleMemberExtend();
    },
    childAgeConfirm(value) {
      this.childAgeActionShow = false;
      this.memberExtendInputDto.childAge = value
      this.handleMemberExtend();
    },

    firstChildAgeConfirm(value) {
      if (value === '无') {
        this.memberExtendInputDto.firstChildAge = ''
      } else {
        this.memberExtendInputDto.firstChildAge = value
      }
      this.firstChildAgeActionShow = false;
      this.handleMemberExtend();
    },

    secondChildAgeConfirm(value) {
      if (value === '无') {
        this.memberExtendInputDto.secondChildAge = ''
      } else {
        this.memberExtendInputDto.secondChildAge = value
      }
      this.secondChildAgeActionShow = false;
      this.handleMemberExtend();
    },

    thirdChildAgeConfirm(value) {
      if (value === '无') {
        this.memberExtendInputDto.thirdChildAge = ''
      } else {
        this.memberExtendInputDto.thirdChildAge = value
      }
      this.thirdChildAgeActionShow = false;
      this.handleMemberExtend();
    },

    carCountConfirm(value) {
      this.carCountActionShow = false;
      this.memberExtendInputDto.carCount = value
      this.handleMemberExtend();
    },
    isHavePetsConfirm(value) {
      if (value === '是') {
        this.memberExtendInputDto.isHavePets = true;
      } else {
        this.memberExtendInputDto.isHavePets = false;
      }
      this.memberExtendInputDto.isHavePetsStr = value;
      this.isHavePetsActionShow = false;
      this.handleMemberExtend();
    },
    childrenNumConfirm(value) {
      this.memberExtendInputDto.childrenNum = parseInt(value);
      // console.log(this.memberExtendInputDto.childrenNum)
      this.childrenNumActionShow = false;
      this.handleMemberExtend();
    },
    handleMemberExtend() {
      // console.log(this.memberExtendInputDto)
      // return
      this.$emit('handleMemberExtend', this.memberExtendInputDto);
    },
    // havePetChange(value) {
    //     this.handleMemberExtend();
    // }
  },
  created() {
    console.log(this.memberExtendInputDto.childrenNum)
    console.log(typeof (this.memberExtendInputDto.childrenNum))
  }
}
